import { Breadcrumbs } from "../components/global/Breadcrumbs"
import { CustomButton } from "../components/global/CustomButton"
import { Product } from "../components/global/Product"
import { SectionTitle } from "../components/global/SectionTitle"
import { UserContext } from "../contexts/UserContext"
import { ProductsContext } from "../contexts/ProductsContext"
import { useContext } from "react"
import "./wishlist.css"

export function Wishlist() {
    const userDataContext = useContext(UserContext)
    const { user } = userDataContext

    const productsDataContext = useContext(ProductsContext)
    const { products } = productsDataContext

    return (
        <div className="wishlist-page mx-auto">

            <Breadcrumbs dynamicPath="Wishlist" />

            <div className="d-flex align-items-center justify-content-between mt-4">

                <h5>Wishlist ({user && user.wishlist.length})</h5>

                <CustomButton
                    color="default"
                    text="Move All To Bag"
                />

            </div>

            <div className="d-flex flex-wrap mt-5 whishlist-items">
                {
                    user && user.wishlist.map((e, i) => (
                        <Product
                            key={i}
                            id={e._id}
                            name={e.title}
                            image={e.image}
                            regularPrice={e.regularPrice}
                            salePrice={e.salePrice}
                            discount={e.discount}
                            newProduct={e.new}
                            rating={e.rating.rate}
                            reviews={e.rating.reviews}
                            wishlist={true}
                        />
                    ))
                }
            </div>
            
            <div className="d-flex justify-content-between align-items-center">

                <SectionTitle title="Just For You" />
                <CustomButton
                    path="/shop"
                    color="default"
                    text="See All"
                />

            </div>

            <div className="d-flex flex-wrap justify-content-between just-for-you">
                {
                    products && products.filter((a, j) => j < 4).map((e, i) => (
                        <Product
                            key={i}
                            id={e._id}
                            name={e.title}
                            image={e.image}
                            regularPrice={e.regularPrice}
                            salePrice={e.salePrice}
                            discount={e.discount}
                            newProduct={e.new}
                            rating={e.rating.rate}
                            reviews={e.rating.reviews}
                        />
                    ))
                }
            </div>

        </div>
    )
}